module.exports = __webpack_public_path__ + "static/media/selectedSDragAndDrop.967b0d9a.png";